<template>

  <BContainer fluid class="container-pages" v-if="dataPageIndex">
  <!-- obican oglas na vrhu -->
  <BRow v-if="$screen.isProduction">
    <BCol cols="12" class="mb-3">
      <div class="a-container">
        <GoogleAdvertisementsIndexDesktopTop />
      </div>
    </BCol>
  </BRow>
  
   <BRow class="mt-4">
      <BCol  v-if="marketPrices.length">
          <!-- =================================================
                    GRAFIK
                ================================================== -->
                <WidgetsStipsMarketPriceHistoryChart
                   
                    :product-name="subcategoryNameLower"
                    :city-name="city"
                    :description="analysisDescription"
                    :prices="marketPrices"
                    :categories="graphCategories"
                    :index-page="true"

                />

    </BCol>
    
    </BRow>
     <!-- Ads (desktop top) -->
    <BRow>
      <BCol cols="12" class="mb-3" v-if="$screen.isProduction">
        <div class="a-container">
          <GoogleAdvertisementsIndexDesktopTop />
        </div>
      </BCol>
    </BRow>
    <BRow class="mb-4 mt-4" v-if="prices.length">
      <BCol >
          <WidgetsStipsMarketPriceSwiper 
                             :prices="prices" 
                             :week="week"></WidgetsStipsMarketPriceSwiper>
      </BCol>
    </BRow>
    <BRow v-if="subcategories.length">
      <BCol class="mb-4 mt-4">
         <WidgetsStipsTopCategory 
              :categories="subcategories" /> 
      </BCol>
    </BRow>
 
    <!-- Istaknuti oglasi (ovo je tvoj CMS komponent) -->
    <BRow class="mb-3" v-if="adsL.length">
      <BCol>
        <CmsProductNewProductsAd     
          :products="adsL"
          :key="0"
          type="approved"
          title="Iskoristite kupon za popust"
          paginate="swiper-pagination"
          btn_prev="swiper-button-prev-tc-top"
          btn_next="swiper-button-next-tc-top"
          class="mt-2"
        />
      </BCol>
    </BRow>
     <BRow class="mt-5" v-if="suggestions.length">
      <BCol>
         <WidgetsFollowSuggestionFollow :suggestions="suggestions" /> 
      </BCol>
    </BRow>
    <BRow class="mt-5">
      <!-- TopAds -->
      <BCol xl="4" lg="6" md="6" sm="12" cols="12">
        <!-- SEO nije presudno, ali može SSR -->
        <WidgetsAdvertisementTopAds :items="adsT" />
      </BCol>

      <!-- Ads (mobile top) -->
      <BCol cols="12" class="mb-3" v-if="$screen.showMobileAds">
        <div class="a-container">
          <GoogleAdvertisementsIndexMobileTop />
        </div>
      </BCol>

      <!-- TopAdsNew -->
      <BCol xl="4" lg="6" md="6" sm="12" cols="12">
        <WidgetsAdvertisementTopAdsNew :items="adsN" />
      </BCol>

      <!-- Other categories -->
      <BCol xl="4" lg="6" md="6" sm="12" cols="12">
        <WidgetsAdvertisementTopAdsOther
          :items="adsS"
          :category_name="'Stoka'"
        />
      </BCol>

      <!-- Ads (desktop) -->
      <BCol cols="12" class="mb-3" v-if="$screen.showDesktopAds">
        <div class="a-container">
          <GoogleAdvertisementsIndexDesktopTop />
        </div>
      </BCol>

      <BCol xl="4" lg="6" md="6" sm="12" cols="12">
        <WidgetsAdvertisementTopAdsOther
          :items="adsV"
          :category_name="'Voće'"
        />
      </BCol>

      <BCol xl="4" lg="6" md="6" sm="12" cols="12">
        <WidgetsAdvertisementTopAdsOther
          :items="adsP"
          :category_name="'Povrće'"
        />
      </BCol>

      <BCol xl="4" lg="6" md="6" sm="12" cols="12">
        <WidgetsAdvertisementTopAdsOther
          :items="adsZ"
          :category_name="'Živina'"
        />
      </BCol>

      <!-- Events -->
      <BCol xl="4" lg="6" md="6" sm="12" cols="12">
        <WidgetsEventTopEvent
          :items="events"
          :month="month"
          :year="year"
        />
      </BCol>

      <BCol xl="4" lg="6" md="6" sm="12" cols="12">
        <WidgetsEventTopEventNoImage
          :items="events"
          :category_name="'Kalendar događaja i manifestacija'"
          :month="month"
          :year="year"
        />
      </BCol>

      <BCol xl="4" lg="6" md="6" sm="12" cols="12">
        <WidgetsEventTopEventNoImage
          :items="events"
          :category_name="'Kalendar događaja i manifestacija'"
          :month="month"
          :year="year"
          :from="8"
          :to="16"
        />
      </BCol>
      <BCol xl="4" lg="6" md="6" sm="12" cols="12">
        <WidgetsEventTopEventNoImage
          :items="events"
          :category_name="'Program'"
          :month="month"
          :year="year"
        />
      </BCol>
      <BCol xl="4" lg="6" md="6" sm="12" cols="12">
        <WidgetsEventTopEventNoImage
          :items="events"
          :category_name="'Koncerti'"
          :month="month"
          :year="year"
        />
      </BCol>
      <BCol xl="4" lg="6" md="6" sm="12" cols="12">
        <WidgetsEventTopEventOther
          :items="events"
          :category_name="'Kalendar stočnih pijaca'"
          :month="month"
          :year="year"
        />
      </BCol>

      <!-- Ads (desktop bottom) -->
      <BCol cols="12" class="mb-3" v-if="$screen.showDesktopAds">
        <div class="a-container">
          <GoogleAdvertisementsIndexDesktopBottom />
        </div>
      </BCol>

     
    </BRow>

    <!-- Market (SSR ok) -->
     <WidgetsMarketTopMarket
      v-if="retails.length"
      :products="retails"
      type="approved"
      title="Cene u marketima"
      paginate="swiper-pagination-prices"
      btn_prev="swiper-button-prev-tc-top-prices"
      btn_next="swiper-button-next-tc-top-prices"
      class="mt-2 pb-2 mb-5"
    /> 

    <!-- SEO bitno: NE lazy -->
    <WidgetsStipsTopPriceBlock title-tag="h2" class="cv-auto" style="--cv-h: 820px"></WidgetsStipsTopPriceBlock>
    <WidgetsPriceTopPriceBase :categories="categories" title-tag="h2" class="cv-auto" style="--cv-h: 830px" />

    <BRow class="cv-auto" style="--cv-h: 1080px">
      <!-- Newspaper -->
      <BCol xl="4" lg="6" md="6" sm="12" cols="12">
        <WidgetsNewspaperTopNewspaper
          :newspapers="newspapers"
          :category_id="1"
          :category="'vesti'"
        />
      </BCol>

      <BCol xl="4" lg="6" md="6" sm="12" cols="12">
        <WidgetsNewspaperTopNewspaper
          :newspapers="newspapers"
          :category_id="2"
          :category="'preporuke'"
        />
      </BCol>

      <!-- Recipes / Kako pomaže -->
      <BCol xl="4" lg="6" md="6" sm="12" cols="12">
        <WidgetsRecipeTopRecipeNoImg
          :title="'Kako pomaže'"
          :items="medicines"
          :routeTo="'kako-pomaze-kategorije-page'"
          :routeToTitle="'kako-pomaze-category-title-id'"
        />
      </BCol>

      <BCol xl="4" lg="6" md="6" sm="12" cols="12">
        <WidgetsRecipeTopRecipeNoImg
          :title="'Recepti'"
          :items="recipes"
          :routeTo="'recepti-page'"
          :routeToTitle="'recept-category-title-id'"
        />
      </BCol>

      <!-- Other SEO widgets -->
      <BCol xl="4" lg="6" md="6" sm="12" cols="12">
        <WidgetsAnimalTopAnimalName />
      </BCol>

      <BCol xl="4" lg="6" md="6" sm="12" cols="12">
        <WidgetsSickTopProtect />
      </BCol>

      <!-- <BCol xl="4" lg="6" md="6" sm="12" cols="12">
        <WidgetsAnimalTopAnimalBirth />
      </BCol>

      <BCol xl="4" lg="6" md="6" sm="12" cols="12">
        <WidgetsSickTopSickness />
      </BCol>

      <BCol xl="4" lg="6" md="6" sm="12" cols="12">
        <WidgetsFoodTopFood />
      </BCol> -->
    </BRow>

    <!-- Cesta pitanja (isti tekst u FAQPage JSON-LD) -->
    <FaqCard :faq="pocetnaFaq" class="mt-4" />

    <!-- Ads (mobile bottom) -->
    <BRow>
      <BCol cols="12" class="mb-3" v-if="$screen.showMobileAds">
        <div class="a-container">
          <GoogleAdvertisementsIndexMobileBottom />
        </div>
      </BCol>
    </BRow>
  </BContainer>
</template>

<script setup>

import { BContainer, BCol, BRow } from 'bootstrap-vue-next'
 

import { useShareMetaStore } from '~/stores/shareMeta'
import { usePageStore } from '~/stores/page'
import {categoriesGraph} from '~/util/stips/graph/categories.js'
import { slimIndexPage } from '~/util/page/slimIndexPage'


// Store
const shareMeta = useShareMetaStore()
const pageStore = usePageStore()


const route = useRoute()
const dayjs = useDayjs()

const year = ref(new Date().getFullYear())
const month = ref(dayjs().format('MMMM'))

// NOTE: ime ključa za cache
const name = computed(() => 'indexPage')

const { data: pageIndex , error} = await useAsyncData(
  () => `page-${name.value}`,
  () => pageStore.getIndexPage(),
  { watch: [() => name.value], transform: slimIndexPage }
  
)
 

const dataPageIndex = computed(() => pageIndex.value?.data)

const ads = computed(() => pageIndex.value?.data.ads ?? [])
const categories = computed(() => pageIndex.value?.data.categories ?? [])
const events = computed(() => pageIndex.value?.data.events ?? [])
const medicines = computed(() => pageIndex.value?.data.medicines ?? [])
const newspapers = computed(() => pageIndex.value?.data.newspapers ?? [])
const recipes = computed(() => pageIndex.value?.data.recipes ?? [])
const retails = computed(() => pageIndex.value?.data.retails ?? [])
const subcategories = computed(() => pageIndex.value?.data.subcategories ?? [])
const suggestions = computed(() => pageIndex.value?.data.suggestions ?? [])
const comments = computed(() => pageIndex.value?.data.fb_video_comments ?? [])
const prices = computed(() => pageIndex.value?.data.prices?.prices ?? [])
const week = computed(() => pageIndex.value?.data.prices?.week ?? {})
const marketPrices = computed(() => pageIndex.value?.data.lambkin_prices ?? [])
const analysisDescription = computed(() => 'Prosečna mesečna cena jagnjadi izračunata je na osnovu dostupnih nedeljnih STIPS cena za izabrani grad. Analiza obuhvata svih 12 meseci u godini, što omogućava praćenje kretanja cena tokom cele godine.')
const subcategoryNameLower = computed(() => 'cene jagnjadi na pijacama')
const city = computed(() => 'Čačak')
const graphCategories = computed(() => categoriesGraph ?? [])

const adsV = computed(() => ads.value.filter(x => x?.category_name === 'Voće'))
const adsZ = computed(() => ads.value.filter(x => x?.category_name === 'Živina'))
const adsP = computed(() => ads.value.filter(x => x?.category_name === 'Povrće'))
const adsS = computed(() => ads.value.filter(x => x?.category_name === 'Stoka'))

const adsT = computed(() =>
  ads.value.filter(x => x?.top_ad == 1 && x?.top_category == 0 && x?.lawyer == 0)
)

const adsL = computed(() =>
  ads.value.filter(x => x?.lawyer == 1 && x?.top_ad == 1 && x?.top_category == 0)
)

const adsN = computed(() =>
  ads.value.filter(x => x?.top_ad === 0 && x?.top_category === 0)
)

 

// SEO
const siteUrl = 'https://pijace.com'
const canonicalUrl = computed(() => `${siteUrl}${route.fullPath === '/' ? '' : route.fullPath}`)

const headTitle = 'Cene na pijacama - stoka, voće, povrće, žitarice | Pijace'
const headDescription =
  'Cene voća, povrća, stoke i žitarica na pijacama i u marketima u Srbiji. Pregled nedeljnih cena, statistika, vesti iz poljoprivrede, zaštita bilja i korisne informacije.'
const headKeywords = [
  'cene na pijacama',
  'cene u marketima',
  'cena voća',
  'cena povrća',
  'cena stoke',
  'cena žitarica',
  'poljoprivreda',
  'pijace',
  'Srbija',
  'pijace.com',
].join(', ')

const ogImage = `${siteUrl}/1200x630.png`

import FaqCard from '~/components/widgets/Advertisement/FaqCard.vue'
import { pocetnaFaq } from '~/util/seo/pocetnaFaq'

// JSON-LD: FAQPage (isti tekst kao u FaqCard)
const faqLd = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: pocetnaFaq.map(item => ({
    '@type': 'Question',
    name: item.question,
    acceptedAnswer: { '@type': 'Answer', text: item.answer }
  }))
}

const jsonLd = computed(() => ({
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'WebSite',
      '@id': `${siteUrl}/#website`,
      url: siteUrl,
      name: 'Pijace',
      description: headDescription,
      inLanguage: 'sr-RS',
      potentialAction: {
        '@type': 'SearchAction',
        target: `${siteUrl}/pretraga?query={search_term_string}`,
        'query-input': 'required name=search_term_string',
      },
    },
    {
      '@type': 'Organization',
      '@id': `${siteUrl}/#organization`,
      name: 'Pijace',
      url: siteUrl,
      logo: { '@type': 'ImageObject', url: `${siteUrl}/icon-256x256.png` },
    },
    {
      '@type': 'WebPage',
      '@id': `${canonicalUrl.value}#webpage`,
      url: canonicalUrl.value,
      name: headTitle,
      description: headDescription,
      isPartOf: { '@id': `${siteUrl}/#website` },
      inLanguage: 'sr-RS',
    },
  ],
}))

watchEffect(() => {
  shareMeta.setMeta({
    title: headTitle,
    description: headDescription,
    url: canonicalUrl.value,
  })
})

usePijaceSeo({
  title: headTitle,
  description: headDescription,
  url: canonicalUrl,
  type: 'website',
  image: ogImage,
  jsonLd: () => [jsonLd.value, faqLd],
})

// keywords + robots + PWA capable (nije pokriveno composable-om)
// Napomena: rel='icon' i rel='apple-touch-icon' se već postavljaju u
// nuxt.config.ts (app.head.link), pa ovde ne treba ponavljati.
useHead(() => ({
  meta: [
    { name: 'keywords', content: headKeywords },
    { name: 'mobile-web-app-capable', content: 'yes' },
    { name: 'apple-mobile-web-app-capable', content: 'yes' },
    {
      name: 'robots',
      content: 'index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1',
    },
  ],
}))
</script>
